import { render, staticRenderFns } from "./BECViz.vue?vue&type=template&id=7495950a&scoped=true"
import script from "./BECViz.vue?vue&type=script&lang=js"
export * from "./BECViz.vue?vue&type=script&lang=js"
import style0 from "./BECViz.vue?vue&type=style&index=0&id=7495950a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7495950a",
  null
  
)

export default component.exports